import React, { useState } from "react";
export default function ChatForm(props) {
  const [message, setMessage] = useState("");

  const onSend = () => {
    if (props.onSend) {
      props.onSend(message);
    }
    setMessage("");
  };

  const hangleKeyPress = (e) => {
    if (e.key === "Enter" && e.shiftKey) {
      onSend();
    }
  };

  return (
    <>
      <div className="border-top pt-4">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={(e) => hangleKeyPress(e)}
          className="form-control border-0 w-100"
          placeholder="Ваше сообщение"
        />
        <div className="d-flex justify-content-between mt-5">
          <div></div>
          <div>
            <button onClick={onSend} className="btn btn-light ">
              Отправить
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
